import { makeAutoObservable } from 'mobx';
import { EventsService } from '@/modules/_core/services/eventsService';

export class EventStore {
	constructor(private readonly eventsService: EventsService) {
		makeAutoObservable(this);
	}
}
